import { pick } from 'lodash';
import { removeEmpty } from 'utils/helpers';

const PROFILE_MAP = [
  '_id',
  'accountId',
  'emailAddress',
  'firstName',
  'lastName',
  'fullName',
  'photoUrl',
  'mobileNumber',
  'emailAlias',
  'recoveryMobileNumber',
  'passwordChangedAt',
  'isMfaEnabled',
  'roleId',
  'createdAt',
];

type ARGS = {
  data: {
    _id: string;
    accountId: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    fullName: string;
    photoUrl: string;
    mobileNumber: string;
    emailAlias: string;
    recoveryMobileNumber: string;
    passwordChangedAt: string;
    isMfaEnabled: string;
    createdAt: string;
    roleId: string;
    [key: string]: any;
  };
};

const profile = ({ data }: ARGS) => ({
  data: removeEmpty(pick(data, PROFILE_MAP)),
});

export default profile;
